<template>
    <div class="menuAemps">
    
    <nav>
        <router-link to="/crear">Agregar Cartas</router-link>
        <router-link to="/editar">Editar Cartas</router-link>
        <router-link to="/listar">Ver Cartas</router-link>
    </nav>
    </div>
 
   </template>
 
 <script>

 

 
 </script>
 